document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  var isTouch = window.matchMedia('(max-width: 749px)').matches;

  /* ── Story header product images slide in ── */
  gsap.from('#osi-story-img-left', {
    x: -200, opacity: 0, duration: 1.2, ease: 'power2.out',
    scrollTrigger: { trigger: '.osi-story-header', start: 'top 80%' }
  });
  gsap.from('#osi-story-img-right', {
    x: 200, opacity: 0, duration: 1.2, ease: 'power2.out', delay: 0.2,
    scrollTrigger: { trigger: '.osi-story-header', start: 'top 80%' }
  });

  /* ── Rolling image rolls across the screen ── */
  gsap.fromTo('#osi-rodante',
    { x: '-120vw', rotation: 0 },
    {
      x: '120vw', rotation: 1080,
      scrollTrigger: { trigger: '.osi-rodante-section', start: 'top bottom', end: 'bottom top', scrub: 1.5 }
    }
  );

  /* ── Dust sparkles (no-op when targets don't exist on page) ── */
  var d1 = document.querySelectorAll('.osi-dust-one');
  if (d1.length) gsap.from(d1, {
    rotation: -720, scale: 0, stagger: { each: 0.08, from: 'random' }, ease: 'back.out(1.7)',
    scrollTrigger: { trigger: '.osi-story-mezcla', start: 'top 60%', end: 'center center', scrub: 2 }
  });
  var d2 = document.querySelectorAll('.osi-dust-two');
  if (d2.length) gsap.from(d2, {
    rotation: 720, scale: 0, stagger: { each: 0.08, from: 'random' }, ease: 'back.out(1.7)',
    scrollTrigger: { trigger: '.osi-story-mezcla', start: 'center 70%', end: 'bottom bottom', scrub: 2 }
  });

  /* ── FINAL REVEAL — DESKTOP ONLY ──
     On mobile the pin + scrub combo introduced visual gaps
     and unreliable behavior on iOS / Android touch scroll.
     Skipping the timeline entirely on touch means the reveal
     content (text + 3 product images) renders in its natural
     CSS state — fully visible, no transforms, no pin — and
     the user just scrolls past the section like any other.
     Desktop keeps the dramatic stick-at-end + reveal. */
  if (!isTouch) {
    var revealTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.osi-story-mezcla',
        start: 'bottom bottom',
        end: '+=600',
        pin: true,
        pinSpacing: true,
        scrub: 1,
        anticipatePin: 1
      }
    });
    revealTl
      .from('.osi-revelacion__text',             { opacity: 0, scale: 0.8, duration: 0.5 }, 0)
      .from('#osi-product2',                { y: 200, scale: 0.5, opacity: 0, duration: 0.6 }, 0.2)
      .from('#osi-product3, #osi-product4', { y: 250, opacity: 0, stagger: 0.25, duration: 0.6 }, 0.5);
  }
});
